export default __webpack_public_path__ + "static/media/Clearance_Specials_Web_Banner_Category_Cover_V2.52403fae.jpg";